module.exports = __webpack_public_path__ + "images/cd1cd24ae8d0ff5082fa705db4e2b88fe4c27a879ef7bc9ddbc01bae96df3ceb.svg";